import React, { useState, useEffect } from 'react'
import Button from '/react4xp/components/Button'

interface Props {
   tag?: string,
   title: string,
   content?: {
      text: string,
      author?: string,
      position?: string,
      orientation?: string,
   },
   cta?: {
      label: string,
      url: string,
      isExternal?: boolean,
   },
   img?: {
      src: string,
      srcMobile: string,
      alt: string,
   },
   imgLarge?: {
      src: string,
      srcMobile: string,
      alt: string,
   }
   orientation?: string,
   imageAsBackground?: boolean,
   backgroundColor?: 'beige' | 'green' | '',
   contentColor?: string,
   isPrototype?: boolean,
}

export default function EntryCard(props: Props) {
   const {
      tag,
      title,
      content,
      cta,
      img,
      imgLarge,
      orientation,
      imageAsBackground,
      backgroundColor,
      contentColor,
      isPrototype,
   } = props

   const [isMobile, setIsMobile] = useState<boolean>(false)

   useEffect(() => {
      const handleResize = () => {
         const width = window.innerWidth

         if (width < 768) {
            setIsMobile(true)
         } else {
            setIsMobile(false)
         }
      }

      handleResize()

      window.addEventListener('resize', handleResize)

      return () => window.removeEventListener('resize', handleResize)
   }, [])

   return (
      <>
         <div className={`
            entry-card
            ${orientation === 'right' ? 'entry-card--right' : ''}
            ${imageAsBackground ? 'entry-card--background' : ''}
            ${backgroundColor !== ("") ? `entry-card--${backgroundColor}` : ''}
            
            ${contentColor === 'secondary' ? 'entry-card--secondary' : ''}
         `}>
            <div className="grid-container">
               <div className="grid-row">
                  <>
                     {imageAsBackground ? (
                        <>
                           {imgLarge && (
                              <figure className="c-12">
                                 <picture>
                                    <source
                                       media="(min-width: 601px)"
                                       srcSet={imgLarge?.src}
                                    />
                                    <source
                                       media="(max-width: 600px)"
                                       srcSet={imgLarge?.srcMobile}
                                    />
                                    <img src={imgLarge?.src} alt={img?.alt ? img.alt : 'Image'} />
                                 </picture>
                              </figure>
                           )}
                           <div className={`content-wrapper c-lg-7 c-xxl-6 ${orientation === 'right' ? 'start-lg-6 start-xxl-7' : ''} ${content.orientation === 'right' ? 'content-wrapper--right' : ''}`}>
                              {tag && <div className="tag">{tag}</div>}
                              {title && <div className="title font-title">{title}</div>}
                              <div className={`content ${(content.author && content.position) ? 'quote' : ''}`}>
                                 {content.text && <p className="text" dangerouslySetInnerHTML={{ __html: content.text }} suppressHydrationWarning></p>}
                                 {
                                    (content.author || content.position) &&
                                    <div className="credits">
                                       {content.author && <div className="author">{content.author}</div>}
                                       {content.position && <div className="position">{content.position}</div>}
                                    </div>
                                 }
                              </div>
                              {cta && <Button className={`btn btn--${contentColor === 'primary' ? 'primary' : 'secondary'} btn--icon`} href={cta.url} target={cta.isExternal} size='md' rightIcon='ArrowRight'>
                                 {cta.label}
                              </Button>}
                           </div>
                        </>
                     ) : (
                        <>
                           {img && (
                              <figure className={`c-md-6 ${orientation === 'left' ? 'start-md-7' : ''}`}>
                                 <picture>
                                    <source
                                       media="(min-width: 768px)"
                                       srcSet={img?.src}
                                    />
                                    <source
                                       media="(max-width: 767px)"
                                       srcSet={img?.srcMobile}
                                    />
                                    <img src={img?.src} alt={img.alt ? img.alt : 'Image'} />
                                 </picture>
                              </figure>
                           )}
                           <div className={`c-md-5 content-wrapper ${orientation === 'right' ? 'start-md-8' : ''} ${content.orientation === 'right' ? 'content-wrapper--right' : ''}`}>
                              {tag && <div className="tag">{tag}</div>}
                              {title && <div className="title font-title">{title}</div>}
                              <div className={`content ${(content.author && content.position) ? 'quote' : ''}`}>
                                 {content.text && <p className="text" dangerouslySetInnerHTML={{ __html: content.text }} suppressHydrationWarning></p>}
                                 {
                                    (content.author || content.position) &&
                                    <div className="credits">
                                       {content.author && <div className="author">{content.author}</div>}
                                       {content.position && <div className="position">{content.position}</div>}
                                    </div>
                                 }
                              </div>
                              {cta && <Button className={`btn btn--${contentColor === 'primary' ? 'primary' : 'secondary'} btn--icon`} href={cta.url} target={cta.isExternal} size='md' rightIcon='ArrowRight'>
                                 {cta.label}
                              </Button>}
                           </div>
                        </>
                     )}
                  </>
               </div>
            </div>
         </div>
      </>
   )
}